var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-user-form',{attrs:{"add-user-function":"addEmployee","link-back":"employee-list","new-title":"Nový zaměstnanec","show-pickup-place":"","title":"Zaměstanec"}})}
var staticRenderFns = []

export { render, staticRenderFns }